import { Briefcase, Building2, Calendar, CreditCard, FileText, Home, Mail, TrendingUp } from 'lucide-react';

export interface PredefinedDoc {
  key: string;
  label: string;
  icon: React.ComponentType<{ size?: number }>;
  formats: string;
  defaultRequired: boolean;
  description: string;
}

export const PREDEFINED_DOCS: PredefinedDoc[] = [
  {
    key: 'identity',
    label: "Piece d'identite (CNI/Passeport)",
    icon: CreditCard,
    formats: '.pdf,.jpg,.png,.gif,.webp',
    defaultRequired: true,
    description: "Document d'identite officiel avec photo",
  },
  {
    key: 'rccm',
    label: 'RCCM / Registre de commerce',
    icon: FileText,
    formats: '.pdf',
    defaultRequired: false,
    description: 'Registre du commerce et du credit mobilier',
  },
  {
    key: 'statuts',
    label: "Statuts de l'entreprise",
    icon: Building2,
    formats: '.pdf',
    defaultRequired: false,
    description: 'Statuts juridiques de la societe',
  },
  {
    key: 'bilan',
    label: 'Bilan financier',
    icon: TrendingUp,
    formats: '.pdf',
    defaultRequired: false,
    description: 'Derniers etats financiers ou bilan comptable',
  },
  {
    key: 'domicile',
    label: 'Justificatif de domicile',
    icon: Home,
    formats: '.pdf,.jpg',
    defaultRequired: false,
    description: 'Facture ou attestation de domicile recente',
  },
  {
    key: 'motivation',
    label: 'Lettre de motivation',
    icon: Mail,
    formats: '.pdf',
    defaultRequired: false,
    description: 'Lettre decrivant le projet et les motivations',
  },
  {
    key: 'cv',
    label: 'CV / Portfolio',
    icon: Briefcase,
    formats: '.pdf',
    defaultRequired: false,
    description: 'Curriculum vitae ou portfolio professionnel',
  },
  {
    key: 'programme',
    label: "Programme détaillé de l'événement",
    icon: Calendar,
    formats: '.pdf',
    defaultRequired: false,
    description: "Programme et déroulement détaillé de l'événement",
  },
];
